module.exports = __webpack_public_path__ + "static/img/gs-logo.e1673bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gs-logo.png
// module id = lri9
// module chunks = 1